import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal, { Overline } from "@/components/Reveal";

const SERVICES = [
  {
    n: "01",
    name: "Leading Your Team",
    for: "All-hands, town halls & one-on-ones",
    body: "Sound as clear and decisive as your strategy deserves — your audience reads your tone before they process your words.",
  },
  {
    n: "02",
    name: "Facing the Boardroom and the Public",
    for: "Earnings calls, keynotes & live interviews",
    body: "Present with authority, stay composed under pressure, and own the room when directors, analysts, and journalists are listening.",
  },
  {
    n: "03",
    name: "Deals and Negotiations",
    for: "Investor pitches, mergers & client relationships",
    body: "Project confidence, hold your position, and be persuasive without pushing — when how you say it can decide the outcome.",
  },
  {
    n: "04",
    name: "Crisis and Difficult Moments",
    for: "Layoffs, restructuring & public setbacks",
    body: "Deliver hard news with steadiness and humanity, protecting trust when it is most at risk.",
  },
];

export default function Services() {
  return (
    <section data-testid="services-section" className="bg-[#F7F5F1] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <Reveal className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <Overline>Services</Overline>
            <h2 className="mt-6 font-serif text-3xl leading-[1.2] tracking-tight text-[#26282E] sm:text-4xl">
              The right voice for every room.
            </h2>
          </div>
          <Link
            to="/services"
            data-testid="services-overview-link"
            className="group inline-flex items-center gap-2 font-mono text-[11px] font-semibold uppercase tracking-[0.22em] text-[#2F5D8C] transition-colors hover:text-[#254A6E]"
          >
            All Services
            <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </Reveal>
        <div className="mt-14">
          {SERVICES.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <Link
                to="/services"
                data-testid={`service-row-${s.n}`}
                className="group grid gap-4 border-t border-[#26282E]/10 py-8 transition-colors duration-300 hover:bg-[#26282E]/[0.03] sm:grid-cols-12 sm:items-center sm:gap-8 sm:py-10"
              >
                <span className="font-mono text-[11px] tracking-[0.2em] text-[#2F5D8C] sm:col-span-1">{s.n}</span>
                <div className="sm:col-span-5">
                  <h3 className="font-serif text-2xl text-[#26282E] transition-colors duration-300 group-hover:text-[#2F5D8C] sm:text-[1.7rem]">
                    {s.name}
                  </h3>
                  <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.22em] text-[#8A8D94]">{s.for}</p>
                </div>
                <p className="text-[15px] leading-relaxed text-[#5B5E66] sm:col-span-5">{s.body}</p>
                <span className="hidden justify-end sm:col-span-1 sm:flex">
                  <ArrowUpRight
                    size={20}
                    className="text-[#8A8D94] transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#2F5D8C]"
                  />
                </span>
              </Link>
            </Reveal>
          ))}
          <div className="border-t border-[#26282E]/10" />
        </div>
        <Reveal delay={0.2}>
          <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.22em] text-[#8A8D94]">
            Engagements are scoped individually. Fees are discussed in consultation.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
